(function () {
  'use strict';

  if (!location.pathname.startsWith('/blogs/articles/')) return;

  function styleArticleContent() {
    // Target the SPECIFIC .rte that contains the article
    const rte = document.querySelector('.blog-layout__main .rte');
    
    if (!rte || rte.dataset.blogStyled === 'true') return;
    rte.dataset.blogStyled = 'true';

    console.log('🎯 Adding inline styles');

    // H2
    rte.querySelectorAll('h2').forEach(el => {
      el.style.setProperty('color', '#a67350', 'important');
      el.style.setProperty('font-weight', 'bold', 'important');
    });

    // H3
    rte.querySelectorAll('h3').forEach(el => {
      el.style.setProperty('color', '#4e3a2d', 'important');
      el.style.setProperty('font-weight', 'bold', 'important');
    });

    // H4
    rte.querySelectorAll('h4').forEach(el => {
      el.style.setProperty('color', '#5e4636', 'important');
      el.style.setProperty('font-weight', 'bold', 'important');
    });

    // Links
    rte.querySelectorAll('a').forEach(el => {
      el.style.setProperty('color', '#5e4636', 'important');
      el.style.setProperty('text-decoration', 'underline', 'important');
      el.style.setProperty('font-weight', 'bold', 'important');
    });

    // UL
    rte.querySelectorAll('ul').forEach(el => {
      el.classList.add('yoni-egg-blog-ul');
    });

    // Tables
    rte.querySelectorAll('table').forEach(el => {
      el.classList.add('branded-table');
    });

    // Images
    rte.querySelectorAll('img').forEach(img => {
      if (img.closest('.yoniegg-blog-card')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'yoniegg-blog-card';
      img.classList.add('yoniegg-blog-image');
      img.parentNode.insertBefore(wrapper, img);
      wrapper.appendChild(img);
    });

    console.log('✅ Styled!');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', styleArticleContent);
  } else {
    styleArticleContent();
  }

  const observer = new MutationObserver(styleArticleContent);
  observer.observe(document.body, { childList: true, subtree: true });

})();